import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft, ArrowRight, ListTodo, Network, PlusCircle, UserSearch } from 'lucide-react';

const adminLinks = [
  {
    label: 'Manage Tasks',
    description: 'View and manage all tasks in the system',
    icon: ListTodo,
    path: '/a/arche_lit_legion/admin/tasks',
  },
  {
    label: 'Task Tree',
    description: 'Visualize parent-child relationships between tasks',
    icon: Network,
    path: '/a/arche_lit_legion/admin/tasks/tree',
  },
  {
    label: 'Create Task',
    description: 'Add a new task for players to complete',
    icon: PlusCircle,
    path: '/a/arche_lit_legion/admin/tasks/create',
  },
  {
    label: 'User Task Statuses',
    description: "Look up a player's task statuses and override or remove them",
    icon: UserSearch,
    path: '/a/arche_lit_legion/admin/user-statuses',
  },
];

export function AdminDashboardPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <div>
        <Link
          to="/a/arche_lit_legion"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-2"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Lit Legion
        </Link>
        <h1 className="text-2xl font-semibold">Admin Dashboard</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage Lit Legion tasks, NPCs, and player progression
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {adminLinks.map((link) => {
          const Icon = link.icon;
          return (
            <Card
              key={link.path}
              className="hover:bg-muted/50 transition-colors cursor-pointer"
              onClick={() => navigate(link.path)}
            >
              <CardContent className="flex items-center justify-between py-6">
                <div className="flex items-center gap-3">
                  <Icon className="h-5 w-5 text-muted-foreground" />
                  <div>
                    <p className="font-medium">{link.label}</p>
                    <p className="text-sm text-muted-foreground">{link.description}</p>
                  </div>
                </div>
                <ArrowRight className="h-4 w-4 text-muted-foreground" />
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
